var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDD02",
    d: "M12 19.286a7.286 7.286 0 1 0 0-14.572a7.286 7.286 0 0 0 0 14.572"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A2A0C",
    d: "M12.762 17.271c-3.925-4.375-2.978-6.728-4.898-8.738c-.154.921-.15.72-.15 1.911c0 1.08.034 1.003-.274 1.894c-.343.99-.802 2.465-.463 3.588c.171.574.591.844 1.17 1.007c.565.158.973.437 1.491.643c.562.223.874.48 1.732.411c.471-.034 1.225-.42 1.392-.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#895729",
    d: "M7.864 8.533c.086.094.056.026.051.394c0 .489.077.827.15 1.294c.052.3.077.416.077.502c0 .137-.077.227-.342.981c-.215.626-.51 1.513-.515 2.323c-.004.802.275 1.534 1.085 1.873c.274.111.441.163.75.206c.484.072.48-.052.814.192c.531.4 1.268.815 1.984.94c.266.042.686 0 .844.03c.369-.18.708-.267.952-.554c-.952-3-4.217-6.685-5.464-8.571h-.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A86617",
    d: "M13.714 16.714c-2.486-1.341-3.146-3.823-4.157-6.325l.043-.048c-.292.086-.039.043-.3.198c-.609.368-.159.35-.36.77c-.442.922-.845 1.737-.798 2.795c.069 1.539 3.566 3.017 4.895 2.902c.223-.018.514-.202.677-.292"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F59935",
    d: "M9.557 10.389c.154.042.055.77.055.998c-.042.827-.381.857.056.887c2.332 2.512 6.06-.801 6.489-.355c-.343-.845-.66-1.6-1.23-2.302c-.429-.531-2.276-1.157-2.443-1.457c-.193-.351-.819-1.86-1.423-1.723c-.159.034-.111.051-.171.137c.317.943.428 2.379-.849 2.426c-.399-.463-.759-.934-1.307-1.23a.5.5 0 0 0-.232-.056c-.162 0-.325.257-.411.429h.159c.552.835.994.943 1.307 2.246"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA8515",
    d: "M13.714 16.714c.484-.18.896-1.028 1.157-1.448c-2.876.591-5.121-2.855-5.314-3.035c.073-.334.197-1.791 0-1.842c-.395.287-.193.32-.257.857c-.03.223-.078.201-.163.372c-.193.378-.57 1.398-.566 2.148c.013 1.611 2.597 2.893 3.943 2.948c.437.017.883-.073 1.2 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#727070",
    d: "M14.871 15.261c.274-.128.433-.12.583-.368c-1.642.154-5.254-.425-6.283-2.207A.7.7 0 0 0 9 13.2c.064.887.994 1.834 1.812 2.027c.763.176 1.428.201 2.105.201c.613 0 1.238-.017 1.95-.167z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0B0B0",
    d: "M9.171 12.686C8.794 14.73 12.025 15 13.341 15c.72 0 1.406-.043 2.113-.107c.454-.223.703-1.025.75-1.457c-1.552 1.418-5.473.801-6.536-1.162l-.12-.008c-.008.008-.026.008-.03.021l-.09.064c-.137.09-.171.137-.257.335"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECB595",
    d: "M9.69 10.196c.99-.086.522-.583.18-.823l-.823-.802c-.172.026-.335.039-.472.125c-.013.582.065 1.204.352 1.581c.505.03.467-.026.763-.081"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M9.668 12.274c-.27.197-.458.356-.201.823c.381.703 1.041.973 1.765 1.23c.558.172 2.268.244 3.343.244h.622c.398-.304.655-.814 1.007-1.14c.098-.094.081-.591.081-.754c0-.42-.06-.424-.128-.758c-.112-.223-.292-.34-.515-.34c-.334 0-.548.018-.891.117c-.879.248-2.074 1.183-2.966 1.161c-.745-.017-1.298-.608-2.117-.583"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#985B17",
    d: "M10.478 9.017c.017.189.112.077.562.146c.214.034.415.047.664.047c.206-.497-.129-.073.454-.373c-.158-.111-.326.03-.544-.103c-.257-.154-.3-1.346-.279-1.543c-.008-.008-.025-.03-.03-.021l-.098-.09c-.056-.069-.056-.094-.095-.18a1 1 0 0 0-.085-.184l-.133-.142c-.454.737-.343 1.522-.416 2.443"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C2B2A",
    d: "M14.978 13.286c.977-1.098.189-1.513-.72-1.17c-.351.133-.746.441-.424.788c.154.167.771.403 1.144.382"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECB595",
    d: "M11.155 7.149c-.034.222-.043 1.624.416 1.842c.853.069 1.046-.197.681-.797a9.6 9.6 0 0 0-.942-1.337c-.086.137-.018.146-.155.292"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M13.29 10.149c-.103.57 1.178.792 1.272.274c.129-.682-1.187-.716-1.272-.274"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#131011",
    d: "M11.142 12.069c.219.634 1.269.312 1.286-.082c.013-.3-.587-.587-.741-.291c-.236.445-.313.162-.545.373m2.143-.412c.099.279.253.369.665.339a.77.77 0 0 0 .385-.129c.172-.103.185-.129.236-.373c-.171-.386-.544-.386-.669-.321c-.317.15.108.077-.24.321c-.094.065-.252.034-.377.159z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M11.048 10.77c-.386-.261-1.011.497-.656.733c.463.313.96-.532.656-.733"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedBonk0)",
    d: "M13.714 4.997c0 .969 0 1.86-.253 1.86c-.313 0-.416-.394-.557-1.337c-.142-.93.043-1.234.321-1.234c.275 0 .489.227.489.711"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedBonk1)",
    d: "M13.285 8.143a.429.429 0 1 0 0-.857a.429.429 0 0 0 0 .857"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedBonk2)",
    d: "M16.17 5.674c-.412.9-.785 1.727-1.003 1.599c-.27-.163-.189-.583.085-1.534c.275-.94.562-1.123.798-.982c.24.142.325.467.12.917"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedBonk3)",
    d: "M14.952 8.34a.43.43 0 0 1-.79-.067a.43.43 0 1 1 .79.067"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedBonk4)",
    d: "M18.038 7.346c-.81.497-1.551.955-1.697.745c-.184-.261.086-.548.793-1.157c.694-.591 1.054-.591 1.213-.364c.163.231.094.527-.309.776"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedBonk5)",
    d: "M16.092 8.931a.43.43 0 1 1-.47-.718a.43.43 0 0 1 .47.718"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCDCA3",
    fillOpacity: 0.62,
    d: "M12.077 8.901c.004-.111.06-.214.163-.257a.24.24 0 0 1 .287.082c.154.192.325.334.565.381c.108.022.193.103.193.214c0 .103-.085.193-.193.176a1 1 0 0 1-.162-.03c-.258-.069-.618.03-.793.236c-.3.351-.772.583-1.217.583a1.57 1.57 0 0 1-.922-.279c-.086-.064-.073-.188.009-.257s.205-.06.3-.004c.128.072.334.154.613.154c.531 0 1.122-.45 1.157-.999"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedBonk0",
    x1: 5.468,
    x2: 18.343,
    y1: 14.236,
    y2: 6.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#6C1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#DE1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedBonk1",
    x1: 5.442,
    x2: 15.03,
    y1: 14.261,
    y2: 5.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#6C1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#DE1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedBonk2",
    x1: 5.236,
    x2: 14.471,
    y1: 12.808,
    y2: 17.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#6C1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#DE1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedBonk3",
    x1: 5.091,
    x2: 17.582,
    y1: 10.812,
    y2: 7.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#6C1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#DE1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedBonk4",
    x1: 7.776,
    x2: 13.787,
    y1: 10.803,
    y2: 15.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#6C1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#DE1A26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedBonk5",
    x1: 6.412,
    x2: 19.074,
    y1: 7.453,
    y2: 10.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#6C1A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#DE1A26"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonk);
export default __webpack_public_path__ + "static/media/bonk.8b3235029a0a74fd5483b57dca9500cd.svg";
export { ForwardRef as ReactComponent };